import axios from "axios";
import * as actionType from "../../constant/actionType";

export const UpdateUserPassword = (data) => async (dispatch) => {
    // Final CSV Data
    try {
      let formdata = new FormData();
      for (let key in data) {
          formdata.append(key, data[key]);
      }
      const response = await axios({
        method: "patch",
        data: formdata,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        },
        url: `${actionType.environment_url}/api/admin/UpdateUserPassword`,
      });
      return response.data;
    } catch (error) {}
  };

